import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {ApiUrl} from '@emm/core/util/api-url.token';
import {standardRetry} from '@emm/core/util/rx.util';
import {Item} from '@emm/core/models/item.model';
import {ItemLocaleResponse} from '@emm/core/models/locale.model';


@Injectable({ providedIn: 'root' })
export class ItemService {

    constructor(@Inject(ApiUrl) private apiUrl: string, private http: HttpClient) {}



    filterItems(filter: string, itemTypeFilter: string, size: number): Observable<any> {
        const itemType = itemTypeFilter ? itemTypeFilter : '';
        return this.http
            .get(`${this.apiUrl}/items/search?term=${filter}&itemType=${itemType}&limit=${size}`)
            .pipe(
                standardRetry()
            );
    }



    setEnabled(tag: string, enabled: boolean): Observable<any> {
        return this.http
            .post(this.apiUrl + `/items/${tag}/attributes/disabled`, [{
                country: 'US',
                language:'',
                reset: false,
                tag: 'DISABLED',
                value: !enabled
            }])
            .pipe(standardRetry());
    }



    getItemsBySize(size: number): Observable<Item[]> {
        return this.http.get(`${this.apiUrl}/items?size=${size}`).pipe(
            map((response: { items: Item[] }) => response.items),
            standardRetry()
        );
    }



    getAllItems(): Observable<Item[]> {
        return this.http.get(`${this.apiUrl}/items`).pipe(
            map((response: { items: Item[] }) => response.items),
            standardRetry()
        );
    }



    getItem(tag: string): Observable<Item> {
        const url = `${this.apiUrl}/items/${tag}`;
        return this.http.get(url).pipe(standardRetry());
    }



    getItemLocale(tag: string, country: string, language: string): Observable<ItemLocaleResponse> {
        const url = `${this.apiUrl}/items/${tag}/attributes?language=${language}&country=${country}`;
        return this.http.get(url).pipe(standardRetry());
    }



    // todo: eol?
    updateItem(tag: string, updates: any): Observable<Item> {
        return this.http.put(this.apiUrl + '/items/' + tag, updates).pipe(standardRetry());
    }



    deleteItem(tag: string): Observable<any> {
        return this.http.delete(`${this.apiUrl}/items/${tag}`).pipe(standardRetry());
    }



    addChildItems(parentTag: string, children: Item[], isGlobalAdd: boolean): Observable<any> {
        const items: any[] = [];
        children.forEach(({ tag }: Item) => items.push({ tag }));
        return this.http
            .post(`${this.apiUrl}/items/group/${parentTag}/${isGlobalAdd}`, items)
            .pipe(standardRetry());
    }

}
